/**
 * Helper bulan (YYYY-MM) — dipakai halaman Positions (desktop & mobile).
 * Dinamis dari `new Date()`, jadi daftar bulan selalu mengikuti bulan berjalan
 * tanpa perlu edit manual tiap ganti bulan.
 */

const MONTH_NAMES: Record<string, string> = {
  '01': 'Januari', '02': 'Februari', '03': 'Maret', '04': 'April',
  '05': 'Mei', '06': 'Juni', '07': 'Juli', '08': 'Agustus',
  '09': 'September', '10': 'Oktober', '11': 'November', '12': 'Desember',
};

/** Label Indonesia dari "YYYY-MM", misal "2026-08" → "Agustus 2026" */
export function monthLabel(ym: string): string {
  const [y, m] = ym.split('-');
  return `${MONTH_NAMES[m] || m} ${y}`;
}

/** Daftar N bulan terakhir dari sekarang (default: bulan berjalan). */
export function buildMonths(count = 8): { value: string; label: string }[] {
  const out: { value: string; label: string }[] = [];
  const now = new Date();
  for (let i = 0; i < count; i++) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    const y = d.getFullYear();
    const m = d.getMonth() + 1;
    out.push({
      value: `${y}-${String(m).padStart(2, '0')}`,
      label: d.toLocaleDateString('id-ID', { month: 'long', year: 'numeric' }),
    });
  }
  return out;
}
